var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 9.08475C19 11.893 16.7614 14.1695 14 14.1695C11.2386 14.1695 9 11.893 9 9.08475C9 6.27652 11.2386 4 14 4C16.7614 4 19 6.27652 19 9.08475ZM16 9.08475C16 7.96145 15.1046 7.05085 14 7.05085C12.8954 7.05085 12 7.96145 12 9.08475C12 10.208 12.8954 11.1186 14 11.1186C15.1046 11.1186 16 10.208 16 9.08475Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15.6949C17.5899 15.6949 20.5 12.7354 20.5 9.08476C20.5 8.73893 20.4739 8.3993 20.4236 8.06781H21C21.5523 8.06781 22 8.52311 22 9.08476V15.1864C22 15.7481 21.5523 16.2034 21 16.2034H19.75V18.2373C19.75 18.6585 19.4142 19 19 19C18.5858 19 18.25 18.6585 18.25 18.2373V16.2034H5.75V18.2373C5.75 18.6585 5.41421 19 5 19C4.58579 19 4.25 18.6585 4.25 18.2373V16.2034H3C2.44772 16.2034 2 15.7481 2 15.1864V9.08476C2 8.52311 2.44772 8.06781 3 8.06781H7.57645C7.52611 8.3993 7.5 8.73893 7.5 9.08476C7.5 12.7354 10.4101 15.6949 14 15.6949ZM5 12.1356C5.55228 12.1356 6 11.6803 6 11.1186C6 10.557 5.55228 10.1017 5 10.1017C4.44772 10.1017 4 10.557 4 11.1186C4 11.6803 4.44772 12.1356 5 12.1356Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjector);
export default __webpack_public_path__ + "static/media/projector.676b22b9cb9b788d5e05dba63710e4c7.svg";
export { ForwardRef as ReactComponent };